
module.exports = {
	status: 'ready',
	title: 'Fakta',
	notes: '',
	context: {
		title: 'Fakta',
		bgColor: 'green',
		items: [
			'Consectetur adipiscing elit.',
			'Mauris faucibus quis dui nec cursus.',
			'Vestibulum dapibus metus maximus tellus.',
			'Nunc in leo vel purus viverra lacinia. ',
			'Pellentesque dignissim elit at neque elementum euismod. ',
			'Nam erat nisi scelerisque eget interdum.',
			'Mauris in facilisis tortor.',
		],
		text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris faucibus quis dui nec cursus. Vestibulum dapibus metus maximus tellus rutrum accumsan sodales eget elit. Nunc in leo vel purus viverra lacinia. Pellentesque dignissim elit at neque elementum euismod. Nam erat nisi, scelerisque eget interdum ac, molestie eget tortor. Mauris in facilisis tortor.</p>'
	},
};
